import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import LayoutRoutes from "./LayoutRoutes";
import PrivateRoutes from "./PrivateRoutes";
import SignIn from "../Auth";
import ForgotPassword from "../ForgotPassword";

export default function Routers() {
  const login = localStorage.getItem("login");

  return (
    <BrowserRouter>
      <Routes>
        {/* Redirect root route based on login */}
        <Route
          path="/"
          element={
            login ? (
              <Navigate to="/dashboard" />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* Protected routes */}
        <Route path="/" element={<PrivateRoutes />}>
          <Route path="/*" element={<LayoutRoutes />} />
        </Route>

        {/* Public routes */}
        <Route path="/login" element={<SignIn />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
      </Routes>
    </BrowserRouter>
  );
}